export default __webpack_public_path__ + "static/media/meet-minerva-screen-4.3a774b8b.jpg";